import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#F0F1F2",
      "fill-rule": "evenodd",
      d: "M10 18.333a8.333 8.333 0 1 1 0-16.666 8.333 8.333 0 0 1 0 16.666",
      "clip-rule": "evenodd"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#7D818A",
      d: "M7.643 6.464 10 8.822l2.357-2.358 1.179 1.18L11.178 10l2.358 2.357-1.18 1.179L10 11.178l-2.357 2.358-1.179-1.18L8.822 10 6.464 7.643z"
    }, null, -1)
  ]))]))
}
export default { render: render }